/* global Razorpay */
import React, { useEffect } from "react";
import "./paymentFailed.css";
import step1 from "assets/choosePlan-image/icon_step1_choose_plan_active.svg";
import step2 from "assets/choosePlan-image/icon_step2_choose_plan_active.svg";
import step3 from "assets/choosePlan-image/icon_step3_choose_plan_active.svg";
import payment_failed from "assets/payment/payment_failed.gif";
import Meta from "utils/meta";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import PricingHeader from "../../Component/PricingHeader/pricingHeader";

const PaymentFailed = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { description } = location.state || {};
  const { subscriptionId } = useParams();

  const handleRazorpayPayment = (subscriptionId) => {
    const options = {
      key: "rzp_test_EZJCnSKZJmmHrw",
      subscription_id: subscriptionId,
      name: "The Realtor Desk",
      description: "Payment for Plan",
      handler: (paymentResponse) => {
        const { razorpay_payment_id, razorpay_subscription_id } =
          paymentResponse;
        navigate("/payment-success", {
          state: {
            razorpay_payment_id,
            razorpay_subscription_id,
          },
        });
      },
      theme: { color: "#3399cc" },
    };
    const rzp = new Razorpay(options);
    rzp.on("payment.failed", (paymentFailedResponse) => {
      const errorDetails = paymentFailedResponse?.error || {};
      const { description } = errorDetails;
      navigate(`/payment-failed/${subscriptionId}`, {
        state: {
          description,
        },
      });
    });
    rzp.open();
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<div className="container">
      <Meta title="Payment Failed | The Realtor Desk" description="" />
      <div className="paymentFailed-container">
        <PricingHeader
            title="Register your account with us, it's free"
            subTitle=""
            step1={step1}
            step2={step2}
            step3={step3}
            isLine1Active={true}
            isLine2Active={true}
        />
        <div className="paymentFailed-box">
          <div className="paymentFailed-gif">
            <img src={payment_failed} alt="" />
            <h2>Payment could not be completed</h2>
            <p className="paymentFailed-reason">{description}</p>
          </div>
          <p className="plan-purchase">
            Unfortunately, we were unable to process your payment for
            <strong> The Realtor Desk Premium Plan</strong>. Please try again or
            contact support for assistance.
          </p>
          <div className="paymentFailed-btn">
            <button
              className="try-again-btn"
              onClick={() => handleRazorpayPayment(subscriptionId)}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
